import { ModelBase } from 'store/model-base';

export class StatementPlanChange extends ModelBase {
    public static storeName: string = 'statementPlanChange';

    public displayName: string;
    public lineId: Id;
    public effectiveDate: string;
    public requestDate: string;
    public changeFromPlanCode: string;
    public changeFromPlanName: string;
    public changeToPlanCode: string;
    public changeToPlanName: string;
}
